export default {"src":"/_next/static/media/upload.3864e62e.svg","height":35,"width":36};